import './ChangeLogList.scss';

import { bem } from 'mission-control-common-components';
import InfiniteScroll from 'react-infinite-scroll-component';

import Loader from '../../Loader';
import ChangeLogListEntry from '../ChangeLogListEntry';
import type { Toggles, UseChangeLogList } from '../hooks/types';

const [block, element] = bem('change-log-list');
export interface ChangeLogListProps {
  toggles: Toggles[];
  toggleAt: (index: number, value: boolean | boolean[]) => void;
  loading?: boolean;
  entityType?: string;
  initialLoading?: boolean;
  filteredLogsToShow: UseChangeLogList[];
  hasMore: boolean;
  onNext: () => void;
}

const ChangeLogList = ({
  toggles,
  toggleAt,
  entityType,
  loading,
  initialLoading,
  filteredLogsToShow,
  hasMore,
  onNext,
}: ChangeLogListProps): JSX.Element => {
  if (initialLoading) {
    return (
      <div className="change-log-loader">
        <Loader text="Loading..." />
      </div>
    );
  }

  if (!loading && !initialLoading && !filteredLogsToShow?.length) {
    return <p>No current change log data for this {entityType || 'entity'}.</p>;
  }

  return (
    <section data-testid="change-log-list" id="scrollableDiv" className={block()}>
      <InfiniteScroll
        scrollableTarget="scrollableDiv"
        dataLength={filteredLogsToShow.length}
        next={onNext}
        hasMore={hasMore}
        loader={<></>}
        style={{ overflow: 'visible' }}
      >
        {filteredLogsToShow.map(
          (filteredChangeLogEntry): JSX.Element => {
            return (
              <ChangeLogListEntry
                {...filteredChangeLogEntry}
                toggles={toggles}
                toggleAt={toggleAt}
                originalIndex={filteredChangeLogEntry.originalIndex}
                key={`change-log-list-${filteredChangeLogEntry.originalIndex}`}
              />
            );
          }
        )}
      </InfiniteScroll>
      {loading && <div className={element('scroll-loader')}>{<Loader />}</div>}
    </section>
  );
};

export default ChangeLogList;
